import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterMode, SelectorDisplayData, SelectorTranslationTexts } from '../../models/selector.model';

@Component({
  standalone: false,
  selector: 'adspt-global-selector-dialog-content',
  templateUrl: './global-selector-dialog-content.component.html',
  styleUrls: ['./global-selector-dialog-content.component.scss'],
})
export class GlobalSelectorDialogContentComponent {
  filterMode = FilterMode;
  @Input() isVisible: boolean;
  @Input() hasDestinationSelector: boolean;
  @Input() enableAdvancedFilterSelection: boolean;
  @Input() enableAdvancedMode: boolean;
  @Input() selectedTabIndex = 0;

  @Input() rowItemTmpl: TemplateRef<any>;
  @Input() subfilterOptions;
  @Input() obs = {
    data: Observable<SelectorDisplayData>,
    translations: Observable<SelectorTranslationTexts>,
    listLoader: Observable<boolean>,
  };
  @Input() srcList: Observable<any>;
  @Input() destList: Observable<any>;
  @Input() srcTotalCount: Observable<number>;
  @Input() destTotalCount: Observable<number>;
  @Input() hasSrcQuery: Observable<boolean>;
  @Input() hasDestQuery: Observable<boolean>;
  @Input() heapInfo;

  @Output() notfiy = new EventEmitter();
  @Output() selectedTabIndexChange = new EventEmitter();
  @Output() refinerChange = new EventEmitter();
}
